// Media is stored either as a URL string or as an object carrying a render recipe.
export const postMediaUrl = (item) =>
  typeof item === "string" ? item : (item?.url ?? "");

export const postMediaUrls = (media = []) =>
  (Array.isArray(media) ? media : []).map(postMediaUrl).filter(Boolean);

// A reel is a video; the rest render as images.
export const isVideoMedia = (post, url = "") =>
  post?.type === "reel" ||
  post?.post === "reel" ||
  /\.(mp4|mov|m4v|webm)(\?|$)/i.test(url);

// These never reached the provider, so they can still be stopped or removed.
const CANCELLABLE_STATUSES = ["pending", "awaitingApproval"];

export const canCancelSocialPost = (post) =>
  CANCELLABLE_STATUSES.includes(String(post?.status ?? "").toLowerCase());

export const canDeleteSocialPost = (post) =>
  canCancelSocialPost(post) ||
  String(post?.status ?? "").toLowerCase() === "cancelled";
